import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { pressreleases } from 'src/app/core/translations/pressreleases';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-press-releases',
  templateUrl: './press-releases.component.html',
  styleUrls: ['./press-releases.component.scss']
})
export class PressReleasesComponent implements OnInit {

  isHandsetPortrait: boolean = false;

  bannerImage: any ='';
  bannerClass: any ='';

  currentLanguage: string = '';
  languageTranslations: any = pressreleases;
  activeLanguageTranslations: any = {};
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {

    this.bannerClass = environment.pageClass;
    this.bannerImage = environment.staticPageBanner;
    
    if (this.route.snapshot.paramMap.get('language')) {
      let language: string | null =
        this.route.snapshot.paramMap.get('language');

      if (language) {

        this.activeLanguageTranslations = this.languageTranslations[language];

        //console.log(this.activeLanguageTranslations);
      }
    }
  }

  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
  }
}
